import React from 'react';
const AuthContext = React.createContext({});
export const CacheContext = React.createContext({});
export default AuthContext;